import { colors } from "constants/colors";
import styled, { css } from "styled-components";

export type StyledTypographyProps = {
  width?: string;
  fontSize?: "small" | "medium" | "large";
  textAlign?: "left" | "center" | "right";
  fontWeight?: React.CSSProperties["fontWeight"];
  lineHeight?: string;
  color?: string;
  inLineBlocK?: boolean;
  backgroundColor?: string;
};

export const FONT_SIZE_MAP: { [fontSize: string]: string } = {
  small: "10px",
  medium: "14px",
  large: "20px",
};

export const StyledTypography = styled.span<StyledTypographyProps>`
  ${({ width }) =>
    width &&
    css`
      width: ${width};
    `};
  font-size: ${({ fontSize }) =>
    fontSize ? FONT_SIZE_MAP[fontSize] : FONT_SIZE_MAP["medium"]};
  color: ${({ color }) => (color ? color : colors.black)};
  text-align: ${({ textAlign }) => textAlign || "left"};
  word-break: break-all;
  overflow-wrap: break-word;
  word-wrap: break-word;
  white-space: pre-line;

  ${({ fontWeight }) =>
    fontWeight &&
    css`
      font-weight: ${fontWeight};
    `};

  ${({ backgroundColor }) =>
    backgroundColor &&
    css`
      background-color: ${backgroundColor};
    `};
  ${({ lineHeight }) =>
    lineHeight &&
    css`
      line-height: ${lineHeight};
    `}
  ${({ inLineBlocK }) =>
    inLineBlocK &&
    css`
      display: inline-block;
    `};
`;
